/**
 * @flow
 * @relayHash 39f6066e5ec6830c27d446d1f9ad2c2d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DeleteIntegrationModal_integration$ref = any;
export type IntegrationsQueryVariables = {||};
export type IntegrationsQueryResponse = {|
  +integrations: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +source: {|
          +id: string,
          +name: string,
          +description: ?string,
          +logo: ?string,
        |},
        +$fragmentRefs: DeleteIntegrationModal_integration$ref,
      |}
    |}>
  |}
|};
export type IntegrationsQuery = {|
  variables: IntegrationsQueryVariables,
  response: IntegrationsQueryResponse,
|};
*/


/*
query IntegrationsQuery {
  integrations {
    edges {
      node {
        id
        source {
          id
          name
          description
          logo
        }
        ...DeleteIntegrationModal_integration
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment DeleteIntegrationModal_integration on Integration {
  id
  source {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "source",
  "storageKey": null,
  "args": null,
  "concreteType": "IntegrationSource",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "logo",
      "args": null,
      "storageKey": null
    }
  ]
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "IntegrationsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "integrations",
        "name": "__Integrations_integrations_connection",
        "storageKey": null,
        "args": null,
        "concreteType": "IntegrationConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "IntegrationEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Integration",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "DeleteIntegrationModal_integration",
                    "args": null
                  }
                ]
              },
              (v3/*: any*/)
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "IntegrationsQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "integrations",
        "storageKey": null,
        "args": null,
        "concreteType": "IntegrationConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "IntegrationEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Integration",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/)
                ]
              },
              (v3/*: any*/)
            ]
          },
          (v4/*: any*/)
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "integrations",
        "args": null,
        "handle": "connection",
        "key": "Integrations_integrations",
        "filters": null
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "IntegrationsQuery",
    "id": null,
    "text": "query IntegrationsQuery {\n  integrations {\n    edges {\n      node {\n        id\n        source {\n          id\n          name\n          description\n          logo\n        }\n        ...DeleteIntegrationModal_integration\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DeleteIntegrationModal_integration on Integration {\n  id\n  source {\n    id\n    name\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "integrations"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '76ea324bd840061374ccd17f8ad5d2f7';
module.exports = node;
